import { z } from "zod";

import { AnalyticsViewTypeList } from "../schemas/analytics/base";

export const EstimatedTestLengthRangeSchema = z.object({
  low: z.number().nullish(),
  high: z.number().nullish(),
});

export type EstimatedTestLengthRangeType = z.infer<
  typeof EstimatedTestLengthRangeSchema
>;

export const ExperienceAnalysisDtoSchema = z.object({
  id: z.string(),
  analysisUrl: z.string().nullable(),
  experienceId: z.string(),
  chosenWinnerVariationId: z.string().nullish(),
  impactWinnerVariationId: z.string().nullish(),
  orders: z.number().nullish(),
  impact: z.number().nullish(),
  visitors: z.number().nullish(),
  analyticsViewType: z.enum(AnalyticsViewTypeList),
  excludeFromImpact: z.boolean().default(false),
  goal: z.string().nullish(),
  controlMonthly: z.number().nullish(),
  impactMetric: z.string().nullish(),
  estimatedTestLengthRange: EstimatedTestLengthRangeSchema.default({
    low: null,
    high: null,
  }).optional(),
});

export type ExperienceAnalysisDto = z.infer<typeof ExperienceAnalysisDtoSchema>;

export const CreateExperienceAnalysisSchema =
  ExperienceAnalysisDtoSchema.extend({
    id: z.string().uuid().optional(),
    experienceId: z.string().uuid().optional(),
  });

export type CreateExperienceAnalysis = z.infer<
  typeof CreateExperienceAnalysisSchema
>;
